import Typography from '@mui/material/Typography';
import { FormControlLabel, Switch } from '@mui/material';
import SelectCurriculum from '../../SelectCustom/SelectCurriculum';

const AssesmentArea = ({ name, element, elementData, childrenElements = [], form, elementForm }) => {
  const value = form?.[element?.elementStructureId]?.value || '';
  const dataSelected = childrenElements?.find((item) => item._id === value);
  if (!dataSelected) return null;

  return (
    <>
      {name === 'elementId' ? (
        <Typography variant='inherit' className='font-bold' color='primary' align='right' component='p'>
          {elementData?.name}
        </Typography>
      ) : (
        <FormControlLabel
          control={
            <Switch
              id={`switch-${name}-${element?.elementStructureId}-${element?._id}`}
              color='primary'
              checked={elementForm?.[name] ? elementForm?.[name] === dataSelected?._id || false : false}
              name='subElementId'
              size='small'
            />
          }
          style={{ margin: 0, justifyContent: 'flex-end' }}
          label={
            <Typography
              variant='inherit'
              className='font-bold capitalize'
              color='primary'
              align='right'
              component='p'
            >
              {elementData?.name}
            </Typography>
          }
        />
      )}
      <div className='col-span-3'>
        <Typography>{childrenElements?.find((item) => item._id === value)?.name || ''}</Typography>
      </div>
      {dataSelected?.elements?.map((item) => {
        const elData = elementData?.children?.find((el) => el._id === item.elementStructureId);
        return (
          <AssesmentArea
            key={`${element?.elementStructureId}-${item._id}`}
            element={item}
            childrenElements={item.children}
            form={form[element?.elementStructureId].children}
            elementData={elData}
            name='subElementId'
            elementForm={elementForm}
          />
        );
      })}
    </>
  );
};

const FormDataCode = ({ form, currentCurriculum }) => {
  return (
    <>
      <Typography variant='inherit' className='font-bold' color='primary' align='right' component='p'>
        Name
      </Typography>
      <div className='col-span-3'>
        <Typography variant='inherit' align='left' component='p'>
          {form.name}
        </Typography>
      </div>
      <Typography variant='inherit' className='font-bold' color='primary' align='right' component='p'>
        Type
      </Typography>
      <div className='col-span-3'>
        <Typography variant='inherit' align='left' component='p'>
          {form.type}
        </Typography>
      </div>
      <Typography variant='inherit' className='font-bold' color='primary' align='right' component='p'>
        Curriculum
      </Typography>
      <div className='col-span-3'>
        <SelectCurriculum
          id='curriculum-level'
          name='curriculumId'
          value={form?.curriculumId}
          isPreview={true}
        />
      </div>
      <AssesmentArea
        element={currentCurriculum?.elements}
        elementData={currentCurriculum?.elementsStructure}
        childrenElements={currentCurriculum?.elements?.children}
        form={form.groupElement || {}}
        name='elementId'
        elementForm={{
          elementId: form.elementId,
          subElementId: form.subElementId
        }}
      />
    </>
  );
};


export default FormDataCode;
